export default __webpack_public_path__ + "static/media/GES_G_WHITE.e9f1feba.png";